<script>
export default {
  props: {
    loading: Boolean,
    schema: {
      type: Array,
      default: () => ["col-6"]
    }
  }
};
</script>

<template>
    <template v-if="loading">
      <span v-for="(item, i) in schema" :key="i" class="placeholder-glow mb-1 d-inline-block w-100">
        <span class="placeholder" :class="item"></span>
      </span>
    </template>

    <template v-else>
      <slot />
    </template>
</template>